import React, { useState } from "react";
import emailjs from "emailjs-com";
import { Mail, Phone, MapPin, Linkedin, Instagram, Youtube, Facebook } from "lucide-react";

const initialState = { name: "", email: "", message: "" };

export const Contact = () => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((p) => ({ ...p, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    emailjs
      .sendForm("service_fatd7wn", "template_dkfzg8z", e.target, "dW6FE4FdGGvC8bPb0")
      .then(
        () => {
          clearState();
          setSending(false);
          alert("Message sent successfully!");
        },
        () => {
          setSending(false);
          alert("Failed to send. Please try again.");
        }
      );
  };

  const inputBase =
    "w-full rounded-xl bg-white/[0.04] border border-white/10 px-4 py-3.5 text-white placeholder:text-slate-500 outline-none focus:border-blue-400/60 focus:bg-white/[0.06] focus:ring-4 focus:ring-blue-500/10 transition";

  const info = [
    { icon: MapPin, label: "Office", value: "Chandigarh, India" },
    { icon: Mail, label: "Email", value: "sudeesha23@gmail.com", href: "mailto:sudeesha23@gmail.com" },
    { icon: Phone, label: "Phone", value: "+91 96468 32734", href: "tel:+919646832734" },
  ];

  const socials = [
    [Linkedin, "https://www.linkedin.com/company/sudeesha-solutions"],
    [Facebook, "https://www.facebook.com/profile.php?id=61559863916281"],
    [Instagram, "https://www.instagram.com/sudeesha23/"],
    [Youtube, "https://www.youtube.com/@Sudeesha23"],
  ];

  return (
    <section id="contact" className="relative bg-[#070b18] py-24 overflow-hidden">
      <div className="absolute -top-10 left-1/4 w-[460px] h-[460px] rounded-full bg-blue-700/15 blur-[130px]" />
      <div className="absolute bottom-0 right-1/4 w-[420px] h-[420px] rounded-full bg-violet-700/15 blur-[130px]" />

      <div className="relative max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">
          {/* LEFT — info */}
          <div className="flex flex-col justify-center">
            <span className="eyebrow reveal">Get In Touch</span>
            <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
              Let's build <span className="text-gradient">something great</span>
            </h2>
            <p className="reveal d2 mt-4 text-slate-400 leading-relaxed max-w-md">
              Tell us about your project and we'll reply quickly with a plan &amp;
              estimate. No obligation — just a friendly conversation.
            </p>

            <div className="reveal d3 mt-8 space-y-3">
              {info.map(({ icon: Icon, label, value, href }) => {
                const Body = (
                  <div className="flex items-center gap-4 rounded-2xl glass p-4 hover:bg-white/[0.06] transition">
                    <span className="h-11 w-11 rounded-xl bg-gradient-to-br from-blue-600 to-violet-600 grid place-items-center">
                      <Icon className="h-5 w-5 text-white" strokeWidth={2.3} />
                    </span>
                    <div>
                      <div className="text-xs font-bold uppercase tracking-wide text-slate-500">{label}</div>
                      <div className="text-white font-semibold">{value}</div>
                    </div>
                  </div>
                );
                return href ? (
                  <a key={label} href={href} className="block">{Body}</a>
                ) : (
                  <div key={label}>{Body}</div>
                );
              })}
            </div>

            <div className="reveal d4 mt-6 flex gap-3">
              {socials.map(([Icon, href], i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="h-11 w-11 rounded-xl glass grid place-items-center text-slate-300 hover:text-white hover:bg-white/10 hover:-translate-y-0.5 transition"
                >
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* RIGHT — form */}
          <div className="reveal d2 rounded-3xl glass-strong p-7 md:p-9">
            <form name="sentMessage" onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-bold text-slate-300 mb-2">Name</label>
                  <input type="text" name="name" className={inputBase} placeholder="Your name" required value={name} onChange={handleChange} />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-300 mb-2">Email</label>
                  <input type="email" name="email" className={inputBase} placeholder="you@email.com" required value={email} onChange={handleChange} />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-slate-300 mb-2">Message</label>
                <textarea name="message" className={`${inputBase} min-h-[150px] resize-none`} placeholder="Tell us about your project..." required value={message} onChange={handleChange} />
              </div>

              <button
                type="submit"
                disabled={sending}
                className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl font-extrabold text-white bg-gradient-to-br from-blue-600 to-violet-600 btn-glow hover:-translate-y-0.5 transition disabled:opacity-60 disabled:translate-y-0"
              >
                {sending ? "Sending..." : "Send Message"}
              </button>

              <p className="text-center text-xs text-slate-500">
                We typically reply within one business day.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
